/**
 * État du job d'un export d'écritures comptables, distinct du statut métier
 * (`new` / `extracted`) : un export `new` peut être échoué.
 * Contrat : `b4cash-srv/documentation/interfaces/ACCOUNT_ENTRY_EXPORT_API.md` §2 (#1105).
 */
export enum AccountEntryExportProcessingStatus {
    Pending = 'pending',
    InProgress = 'in_progress',
    Done = 'done',
    Failed = 'failed',
}

export const ACCOUNT_ENTRY_EXPORT_PROCESSING_STATUSES: AccountEntryExportProcessingStatus[] = [
    AccountEntryExportProcessingStatus.Pending,
    AccountEntryExportProcessingStatus.InProgress,
];

/**
 * Config visuelle de l'état du job pour rendu badge `<p-tag>`.
 * Aligné sur le pattern `InvoiceProcessingStatusConfig`.
 */
export interface AccountEntryExportProcessingStatusConfig {
    label: string;
    severity: 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined;
    spinning?: boolean;
}
